import { PermissionsKey } from '@vedalib/crud'

import { usePermissionContext, usePermissions } from 'services/Permission/PermissionContext'

export const useCanViewProfile = (employeeId?: string) => {
  const permissions = usePermissions()
  const { identityData } = usePermissionContext()
  const canReadProfile = permissions.has(PermissionsKey.company_employees_list_profile_r)
  return canReadProfile || identityData.employee?.id === employeeId
}
